import { VerticalAlignment } from "./types"

export const getTextStyle = ({ content }) => {

    const style = {
        backgroundColor: "",
        backgroundImage: "",
        backgroundSize: "",
        backgroundRepeat: "",
        backgroundPosition: "",
    }

    if (content.backgroundColor) {
        style.backgroundColor = content.backgroundColor
    }

    if (content.backgroundImage) {
        const imageUrl = content.backgroundImage.attributes.publicUrlBySize["1280x800"] ||
            content.backgroundImage.attributes.publicUrl
        style.backgroundImage = "url("+ imageUrl +")"
        style.backgroundSize = "cover"
        style.backgroundRepeat = "no-repeat"
        style.backgroundPosition = "center"
    }

    return style
}

export const getImageAlignment = ({ alignment }) => {
    switch (alignment) {
    case "left":
        return "justify-content-start"
    case "right":
        return "justify-content-end"
    default:
    case "center":
        return "justify-content-center"
    }
}


export const getImageClassName = ({ size, isPdf }) => {
    switch (size) {
    case "15":
        return isPdf ? "col-2" : " col-lg-2 col-md-3 col-4"
    case "25":
        return isPdf ? "col-3" : " col-lg-3 col-md-4 col-5"
    case "50":
        return " col-lg-6 col-md-6 col-6"
    case "75":
        return " col-lg-9 col-md-9 col-9"
    case "100":
        return " col-lg-12 col-md-12 col-12"
    default: 
        return "col-md-12"
    }
}

export const VerticalAlignmentClassName = {
    [VerticalAlignment.MIDDLE]: "center",
    [VerticalAlignment.BOTTOM]: "end",
    [VerticalAlignment.TOP]: "start"
} 

export const getVerticalAlignmentClassName = (verticalAlignment) => {
    return VerticalAlignmentClassName[verticalAlignment] ?? VerticalAlignmentClassName[VerticalAlignment.MIDDLE]
}


// WEBPACK FOOTER //
// ./src/template/sections/content/text-and-image-row/helpers.ts